import AccountDetailsForm from "./AccountDetailsForm";

export default AccountDetailsForm;
